module.exports = "/_next/static/images/gradientBG2-0525a989763cc5d97dea07c9b5d46600.png";